import React, { FC, Fragment } from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import DisabledCardState from '@components/Cards/DisabledCardState';
import { useUiState } from '@app/utils/UiStateHook';
import { useExerciseInDisguiseController } from './useExerciseInDisguiseController';
import { DateTime } from 'luxon';
import { InfoBubble } from '../InfoBubble';

export interface ExerciseInDisguiseCard2Props {
  groupStart: string | DateTime;
}
export const ExerciseInDisguiseCard2: FC<ExerciseInDisguiseCard2Props> = ({ groupStart }) => {
  const { enabled, disabledMessage, content, openDialog, closeDialog, dialogOpen, learnMoreDisabled } =
    useExerciseInDisguiseController(groupStart);
  const uiState = useUiState(enabled);
  return (
    <Fragment>
      <Card
        variant={'elevation'}
        sx={{
          borderRadius: 4,
          border: '1px solid',
          borderColor: uiState.borderColor,
        }}
      >
        <CardContent>
          <div
            className="title-with-info"
            style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              gap: 6, // space between title and info icon
              flexWrap: 'nowrap',
            }}
          >
            <Typography variant="h5" component="div" color={enabled ? 'primary' : 'textDisabled'}>
              Exercise In Disguise
            </Typography>
            <InfoBubble title="Exercise in Disguise">
              Exercise in Disguise is updated each Monday with a way to think about exercise differently than just
              &quot;going to the gym&quot;.
            </InfoBubble>
          </div>
          {!enabled && (
            <DisabledCardState
              disabledMessage={disabledMessage}
              src="/assets/svg/exercise-disguise-sloth.svg"
              alt="Get stoked!"
            />
          )}
          {enabled && (
            <>
              <div className="card-content-wrapper">
                <img
                  src={'/assets/svg/exercise-disguise-sloth.svg'}
                  alt={'Exercise in Disguise'}
                  className="card-logo"
                />
                <Typography variant="smallCursive" component="p" className="card-copy">
                  {content.title}
                </Typography>
              </div>
              <CardActions
                sx={{
                  alignItems: 'end',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  flexDirection: 'column',
                }}
              >
                <Button disabled={learnMoreDisabled} variant="contained" color="primary" onClick={openDialog}>
                  Learn More
                </Button>
              </CardActions>
            </>
          )}
        </CardContent>
      </Card>
      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>{content.title || ''}</DialogTitle>
        <DialogContent>
          <Typography dangerouslySetInnerHTML={{ __html: content.body || '' }}></Typography>
        </DialogContent>
        <DialogActions>
          <Button variant={'contained'} onClick={closeDialog}>
            Got It!
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};
